import { Dialog } from "primereact/dialog";
import { useState, useEffect } from "react";
import usePollStore from "~/store/pollStore";
import "./PollModal.css";

const ACTIVE_POLL = {
  id: "poll-1",
  options: [
    {
      id: "dom",
      label: "Livro de Ofertas (DOM)",
      description:
        "Visualize a profundidade do mercado com ordens de compra e venda em tempo real",
      icon: "pi pi-list",
      image: "/assets/images/poll-dom.png",
    },
    {
      id: "boleta",
      label: "Boleta de Negociação",
      description: "Revise, ajuste e execute com precisão",
      icon: "pi pi-file-edit",
      image: "/assets/images/poll-boleta.png",
    },
    {
      id: "boletaTurbo",
      label: "Boleta Turbo",
      description: "Operações rápidas com um clique — scalping e day trade",
      icon: "pi pi-bolt",
      image: "/assets/images/poll-boleta-turbo.png",
    },
  ],
};

export const PollModal = ({ visible, onDismiss }) => {
  const [selectedChoice, setSelectedChoice] = useState(null);
  const [showThanks, setShowThanks] = useState(false);
  const submitVote = usePollStore((s) => s.submitVote);

  // Reset state when modal opens
  useEffect(() => {
    if (visible) {
      setSelectedChoice(null);
      setShowThanks(false);
    }
  }, [visible]);

  const handleVote = async (choice) => {
    if (showThanks) return;
    setSelectedChoice(choice);
    setShowThanks(true);
    await submitVote(choice);
    setTimeout(() => onDismiss(), 800);
  };

  const handleSkip = () => {
    onDismiss();
  };

  return (
    <Dialog
      visible={visible}
      modal
      closable={false}
      className="poll-modal"
      data-evo-id="poll-modal"
      style={{ width: "min(550px, 92vw)" }}
      header={
        <div className="poll-modal-header">
          <i
            className="pi pi-megaphone"
            style={{ fontSize: "1.1rem", marginRight: "0.375rem" }}
          />
          Ajude a escolher a próxima feature!
        </div>
      }
    >
      <div className="poll-step-content" data-evo-id="poll-section">
        <p className="poll-subtitle">
          Qual funcionalidade você mais gostaria de ver no Charts 26?
        </p>
        <div className="poll-grid-vertical">
          {ACTIVE_POLL.options.map((option) => (
            <button
              key={option.id}
              className={`poll-card-v ${selectedChoice === option.id ? "poll-card-selected" : ""}`}
              onClick={() => handleVote(option.id)}
              disabled={showThanks}
              data-evo-id={`poll-option-${option.id}`}
            >
              <div className="poll-card-image">
                <img
                  src={option.image}
                  alt={option.label}
                  onError={(e) => {
                    e.target.style.display = "none";
                  }}
                />
                <i className={`${option.icon} poll-card-icon-fallback`} />
              </div>
              <div className="poll-card-text">
                <span className="poll-card-label">{option.label}</span>
                <span className="poll-card-description">
                  {option.description}
                </span>
              </div>
            </button>
          ))}
        </div>
        {showThanks && (
          <div className="poll-thanks">
            <i className="pi pi-check-circle" />
            Obrigado pelo seu voto!
          </div>
        )}
        {!showThanks && (
          <button className="poll-skip" onClick={handleSkip}>
            Pular
          </button>
        )}
      </div>
    </Dialog>
  );
};
